import api from "../api.js";
import createEntity from "./createEntity.js";

let tenantInfo = createEntity({ namespaced: false });

const state = {
    tenantDataLoading: false,
};

const mutations = {
    update(state, changes) {
        Object.assign(state, changes);
    }
};

const getters = {
    tenantInfo(state, getters, rootState, rootGetters) {
        return getters["tenantInfo/getAll"]
    },
    tenantDataLoading(state, getters, rootState, rootGetters) {
        return state.tenantDataLoading;
    }
};

const root = { root: true };

const actions = {

    async loadTenantInfo(context) {
        context.commit("update", { tenantDataLoading: true });

        if (context.getters["tenantInfo/getAll"].length) {
            context.commit("update", { tenantDataLoading: false });
            return
        }

        let data = await api.getTenantDataById();

        context.commit("tenantInfo/load", data);

        context.commit("update", { tenantDataLoading: false });
    },
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        tenantInfo
    }
}